import * as Sentry from '@sentry/react';
import type { ComponentProps } from 'react';
import { Routes } from 'react-router';

let WrappedRoutes: typeof Routes | undefined;

/**
 * Sentry names a page load or navigation after the matched route only when it
 * sees every nested `<Routes>`; a plain one leaves the name at `/*`. The wrapper
 * needs Sentry's router integration, which exists only after `Sentry.init` runs
 * during the first render, so it is created then and not at import time.
 */
export function SentryRoutes(props: ComponentProps<typeof Routes>) {
  // Before Sentry.init, or with tracking off, Sentry returns `Routes` itself;
  // keep only a real wrapper so a later render can still wrap.
  const Component = WrappedRoutes ?? Sentry.wrapReactRouterRouting(Routes);
  if (Component !== Routes) WrappedRoutes = Component;
  return <Component {...props} />;
}
